export default "__VITE_ASSET__jt8gPuqg__"